import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SessionStatusState {
  dateLastVisit: Date;
  pathBeforeLoginRequest: string;
}

const initialState: SessionStatusState = {
    dateLastVisit: null,
    pathBeforeLoginRequest: null,
};

const sessionStatusSlice = createSlice({
    name: 'sessionStatus',
    initialState,
    reducers: {
        setWelcomeVisit: (state) => {
            state.dateLastVisit = new Date();
        },
        setPathBeforeLoginRequest: (state, action: PayloadAction<{ path: string }>) => {
            state.pathBeforeLoginRequest = action.payload.path;
        },
        unsetPathBeforeLoginRequest: (state) => {
            delete state.pathBeforeLoginRequest;
        },
    },
});

export const { setWelcomeVisit, setPathBeforeLoginRequest, unsetPathBeforeLoginRequest } = sessionStatusSlice.actions;
export default sessionStatusSlice.reducer;
